import ApiService from "@/core/services/api.service";

export const FETCH_MACHINE_SERVICE_SIGNALS = "fetchMachineServiceSignals";
export const FETCH_MACHINE_SERVICE_SIGNAL = "fetchMachineServiceSignal";
export const DELETE_MACHINE_SERVICE_SIGNAL = "deleteMachineServiceSignal";

export const SET_ERROR = "setMachineServiceSignalError";
export const SET_LOADING = "setLoadingMachineServiceSignal";

const state = {
  errors: [],
  isLoadingMachineServiceSignal: false
};

const getters = {
  isLoadingMachineServiceSignal() {
    return state.isLoadingMachineServiceSignal;
  }
};

const actions = {
  [FETCH_MACHINE_SERVICE_SIGNALS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("machine-service-signals" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_MACHINE_SERVICE_SIGNAL](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("machine-service-signals", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_MACHINE_SERVICE_SIGNAL](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("machine-service-signals", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingMachineServiceSignal = false;
    state.errors = Array.isArray(errors) ? errors : [errors];
  },
  [SET_LOADING](state, value) {
    state.isLoadingMachineServiceSignal = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
